import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { OutputFormatPropertyName, RecognitionMode, RecognizerConfig, SpeechServiceRecognizer } from "../common.speech/Exports";
import { SpeechConnectionFactory } from "../common.speech/SpeechConnectionFactory";
import { Contracts } from "./Contracts";
import { OutputFormat, PropertyId, Recognizer } from "./Exports";
/**
 * Performs speech recognition from microphone, file, or other audio input streams, and gets transcribed text as result.
 * @class SpeechRecognizer
 */

export var SpeechRecognizer = /*#__PURE__*/function (_Recognizer) {
  _inherits(SpeechRecognizer, _Recognizer);

  var _super = _createSuper(SpeechRecognizer);

  /**
   * SpeechRecognizer constructor.
   * @constructor
   * @param {SpeechConfig} speechConfig - An set of initial properties for this recognizer
   * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
   */
  function SpeechRecognizer(speechConfig, audioConfig) {
    var _this;

    _classCallCheck(this, SpeechRecognizer);

    var speechConfigImpl = speechConfig;
    Contracts.throwIfNull(speechConfigImpl, "speechConfig");
    Contracts.throwIfNullOrWhitespace(speechConfigImpl.properties.getProperty(PropertyId.SpeechServiceConnection_RecoLanguage), PropertyId[PropertyId.SpeechServiceConnection_RecoLanguage]);
    _this = _super.call(this, audioConfig, speechConfigImpl.properties, new SpeechConnectionFactory());
    _this.privDisposedSpeechRecognizer = false;
    return _this;
  }
  /**
   * Gets the endpoint id of a customized speech model that is used for speech recognition.
   * @member SpeechRecognizer.prototype.endpointId
   * @function
   * @public
   * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
   */


  _createClass(SpeechRecognizer, [{
    key: "recognizeOnceAsync",

    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     *       so it is suitable only for single shot recognition
     *       like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */
    value: function recognizeOnceAsync(cb, err) {
      this.recognizeOnceAsyncImpl(RecognitionMode.Interactive, cb, err);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */

  }, {
    key: "startContinuousRecognitionAsync",
    value: function startContinuousRecognitionAsync(cb, err) {
      this.startContinuousRecognitionAsyncImpl(RecognitionMode.Conversation, cb, err);
    }
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */

  }, {
    key: "stopContinuousRecognitionAsync",
    value: function stopContinuousRecognitionAsync(cb, err) {
      this.stopContinuousRecognitionAsyncImpl(cb, err);
    }
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     *      Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     *        specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */

  }, {
    key: "startKeywordRecognitionAsync",
    value: function startKeywordRecognitionAsync(model, cb, err) {
      Contracts.throwIfNull(model, "model");

      if (!!err) {
        err("Not yet implemented.");
      }
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     *       Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */

  }, {
    key: "stopKeywordRecognitionAsync",
    value: function stopKeywordRecognitionAsync(cb, err) {
      if (!!cb) {
        cb();
      }
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */

  }, {
    key: "close",
    value: function close() {
      Contracts.throwIfDisposed(this.privDisposedSpeechRecognizer);
      this.dispose(true);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */

  }, {
    key: "dispose",
    value: function dispose(disposing) {
      if (this.privDisposedSpeechRecognizer) {
        return;
      }

      if (disposing) {
        this.implRecognizerStop(); // Dispose is synchronous, so just start it....

        this.privDisposedSpeechRecognizer = true;
      }

      _get(_getPrototypeOf(SpeechRecognizer.prototype), "dispose", this).call(this, disposing);
    }
  }, {
    key: "createRecognizerConfig",
    value: function createRecognizerConfig(speechConfig) {
      return new RecognizerConfig(speechConfig, this.properties);
    }
  }, {
    key: "createServiceRecognizer",
    value: function createServiceRecognizer(authentication, connectionFactory, audioConfig, recognizerConfig) {
      var configImpl = audioConfig;
      return new SpeechServiceRecognizer(authentication, connectionFactory, configImpl, recognizerConfig, this);
    }
  }, {
    key: "endpointId",
    get: function get() {
      Contracts.throwIfDisposed(this.privDisposedSpeechRecognizer);
      return this.properties.getProperty(PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */

  }, {
    key: "authorizationToken",
    get: function get() {
      return this.properties.getProperty(PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    ,
    set: function set(token) {
      Contracts.throwIfNullOrWhitespace(token, "token");
      this.properties.setProperty(PropertyId.SpeechServiceAuthorization_Token, token);
    }
    /**
     * Gets the spoken language of recognition.
     * @member SpeechRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */

  }, {
    key: "speechRecognitionLanguage",
    get: function get() {
      Contracts.throwIfDisposed(this.privDisposedSpeechRecognizer);
      return this.properties.getProperty(PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of recognition.
     * @member SpeechRecognizer.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of recognition.
     */

  }, {
    key: "outputFormat",
    get: function get() {
      Contracts.throwIfDisposed(this.privDisposedSpeechRecognizer);

      if (this.properties.getProperty(OutputFormatPropertyName, OutputFormat[OutputFormat.Simple]) === OutputFormat[OutputFormat.Simple]) {
        return OutputFormat.Simple;
      } else {
        return OutputFormat.Detailed;
      }
    }
    /**
     * The collection of properties and their values defined for this SpeechRecognizer.
     * @member SpeechRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */

  }, {
    key: "properties",
    get: function get() {
      return this.privProperties;
    }
  }]);

  return SpeechRecognizer;
}(Recognizer);